import axiosInstance from "../axiosInstance";

// export const getData = async () => {
//   try {
//     const data = await axiosInstance.get("experience/");
//     return data;
//   } catch (error) {
//     console.log("Error logging in:", error);
//   }
// };

export const getUserData = async () => {
  try {
    const data = await axiosInstance.get("user");
    return data;
  } catch (error) {
    // console.log("Error logging in:", error);
  }
};

export const updateData = async (body: any) => {
  try {
    const data = await axiosInstance.put("user", body);
    return data;
  } catch (error) {
    // console.log("Error logging in:", error);
  }
};
export const updateDataImage = async (body: any) => {
  try {
    const data = await axiosInstance.put("user/info", body);
    return data;
  } catch (error) {
    // console.log("Error logging in:", error);
  }
};

export const getS3URL = async (body: any) => {
  try {
    const data = await axiosInstance.post(
      "document/generate-upload-s3-link",
      body
    );
    return data;
  } catch (error) {
    // console.log("Error logging in:", error);
  }
};

const getBlob = async (fileUri: any) => {
  const resp = await fetch(fileUri);
  const imageBody = await resp.blob();
  return imageBody;
};

export const putImageInS3URL = async (url: string, body: any) => {
  const fromData = new FormData();
  let filepath = body.imageURL;
  const imageBody = await getBlob(filepath);

  const uploadUrl = url;
  // console.log(uploadUrl);
  const resData = await fetch(url, {
    method: "PUT",
    body: imageBody,
  });
  return resData;
};
export const getImageURL = async (body: any) => {
  try {
    const data = await axiosInstance.post("document/get-view-media-link", body);
    return data;
  } catch (error) {
    // console.log("Error logging in:", error);
  }
};
